import { MapPin, Compass } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const ABOUT_IMG = "/media/about-maldives.webp";
const ABOUT_IMG_SRCSET = "/media/about-maldives-720.webp 720w, /media/about-maldives.webp 1440w";

export const AboutSection = () => (
  <section id="about" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="absolute -top-40 -start-40 h-[480px] w-[480px] rounded-full bg-[#C80000]/12 blur-[140px]" aria-hidden="true" />
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <div>
        <SectionHeading caption="نبذة عن الشركة" title="وكالة سفر بحرينية بروح عالمية" />
        <Reveal delay={0.1}>
          <p className="text-sm sm:text-base leading-loose text-slate-600">
            دليل المسافر للحجوزات، وكالة سفر في منطقة السيف بمملكة البحرين. تواصلوا معنا للاستفسار عن رحلتكم وترتيب الحجوزات.
          </p>
          <p className="mt-5 text-sm sm:text-base leading-loose text-slate-600">
            نستقبل استفساراتكم عبر الهاتف أو واتساب، ونسعد بمساعدتكم في التخطيط لرحلتكم القادمة من مكتبنا في قلب منطقة السيف.
          </p>
        </Reveal>
        <Reveal delay={0.2} className="mt-8 flex flex-wrap gap-3">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#C80000]/30 bg-[#C80000]/8 px-4 py-2 text-xs sm:text-sm font-semibold text-brand">
            <Compass className="h-4 w-4" />
            وكالة سفر — Travel Agency
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-100 px-4 py-2 text-xs sm:text-sm font-semibold text-slate-600">
            <MapPin className="h-4 w-4 text-brand" />
            السيف، مملكة البحرين
          </span>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="absolute -inset-3 rounded-[2.2rem] border border-[#C80000]/35 translate-x-4 translate-y-4" aria-hidden="true" />
        <div className="relative overflow-hidden rounded-[2rem] brand-ring">
          <img src={ABOUT_IMG} srcSet={ABOUT_IMG_SRCSET} sizes="(max-width: 1024px) 100vw, 600px" alt="وجهة سفر استوائية فاخرة" loading="lazy" decoding="async" className="h-[320px] sm:h-[440px] w-full object-cover transition-transform duration-700 hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#FFFFFF]/75 via-transparent to-transparent" />
          <div className="absolute bottom-5 start-5 glass rounded-xl px-4 py-3">
            <p className="text-xs tracking-[0.25em] text-brand font-semibold" dir="ltr">TRAVELERS GUIDE</p>
            <p className="text-sm text-slate-900 mt-1">رحلات تُرتَّب بعناية من البحرين</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
